export default "__VITE_ASSET__Bttswhuf__"